import {useLayoutEffect, useRef, useState} from 'react';

import {getValueLabelLayout, type ValueLabelLayout} from './valueLabelLayout';

const INITIAL_LAYOUT: ValueLabelLayout = {left: 0, isMinHidden: false, isMaxHidden: false};

const useValueLabelLayout = (ratio: number) => {
    const rowRef = useRef<HTMLDivElement>(null);
    const valueRef = useRef<HTMLSpanElement>(null);
    const minRef = useRef<HTMLSpanElement>(null);
    const maxRef = useRef<HTMLSpanElement>(null);
    const [layout, setLayout] = useState(INITIAL_LAYOUT);

    useLayoutEffect(() => {
        const row = rowRef.current;
        const valueLabel = valueRef.current;

        if (!row || !valueLabel) return;

        const measure = () =>
            setLayout(
                getValueLabelLayout(ratio, {
                    rowWidth: row.offsetWidth,
                    valueWidth: valueLabel.offsetWidth,
                    minWidth: minRef.current?.offsetWidth ?? 0,
                    maxWidth: maxRef.current?.offsetWidth ?? 0,
                })
            );

        measure();

        // Hidden bounds keep their size, so observing every label catches a text change too.
        const observer = new ResizeObserver(measure);

        for (const element of [row, valueLabel, minRef.current, maxRef.current]) {
            if (element) observer.observe(element);
        }

        return () => observer.disconnect();
    }, [ratio]);

    return {rowRef, valueRef, minRef, maxRef, ...layout};
};

export default useValueLabelLayout;
